import { Button } from "@mantine/core"
import { FormButtonGroup } from "../../../../-components/form-button-group"
import { DateOnly } from "../../../../@client/System"
import { PlanLayoutAttachmentUploadModal } from "./PlanLayoutAttachmentUploadModal"
import { PublishPlanModal } from "./PublishPlanModal"
import { useDisclosure } from "@mantine/hooks"
import { useSuspenseQueryGet } from "../../../../typed-client/hooks/use-suspense-query-get"
import { useTranslation } from "react-i18next"

interface Props {
  planLayoutId: number
  startDate: DateOnly
  endDate: DateOnly
}

export function PublishPlanLayoutControls(props: Props) {
  const [
    publishModalOpened,
    { open: openPublishModal, close: closePublishModal },
  ] = useDisclosure()

  const [
    uploadModalOpened,
    { open: openUploadModal, close: closeUploadModal },
  ] = useDisclosure()

  const { planLayoutId } = props

  const { data: canPublishPlan } = useSuspenseQueryGet(
    "/api/Plans/CanPublishPlans",
    { planLayoutId }
  )

  const { t } = useTranslation("app_server")

  return (
    canPublishPlan && (
      <>
        <FormButtonGroup align="center">
          <Button variant="default" onClick={openUploadModal}>
            {t("UploadPlan")}
          </Button>
          <Button onClick={openPublishModal}>{t("PublishPlan")}</Button>
        </FormButtonGroup>
        <PublishPlanModal
          onClose={closePublishModal}
          opened={publishModalOpened}
          {...props}
        />
        <PlanLayoutAttachmentUploadModal
          opened={uploadModalOpened}
          onClose={closeUploadModal}
          {...props}
        />
      </>
    )
  )
}
